import { getOPCO } from "../../../Shared/helper/helper"

export const CITY_CONFIG = "city-config"
export const AW_TRANSANCTION_TYPE="HBB_LEADS"
export const AW_TRANSANCTION_TYPE_SW="HBB_LEADS_SW"
export const ENTERPRISE="ENTERPRISE"
export const AW_PAYMENT_MODE="HBB_AIRTIME"
export const AIRTIME="AIR_TIME"
export const SERVICE_TYPE="HBB_ODU_AW"
export const AM_PAYMENT_MODE="AIRTEL_MONEY"
export const FORM_SCHEMA=`cms/webpage/activePackage?opco=${getOPCO()}&pageUrl=languagePrefix/get-form-schema`;
export const CONTACT_FORM_SCHEMA=`cms/webpage/activePackage?opco=${getOPCO()}&pageUrl=languagePrefix/get-contact-form-schema`
export const PREPAID = "Prepaid"
export const WEBPORTAL = "WEBPORTAL"
export const INSTALLATION= "INSTALLATION"
export const CHECKBOX = "checkbox"
export const STRING = 'string'
export const WEBSITE = 'WEBSITE'
export const AIRTEL_WORKS='Airtel Works'
export const EN="en"
